import { Helper } from "../../helpers/helper";
import { DropdownOptionInputsReplacementProperties } from "../../models/html.models";

/**
 * Renders `<select>` dropdowns as an equivalent grid of checkbox or radio button inputs, keeping the two in sync.
 */
export class OptionInputsUtility {

    /**
     * Replaces select elements with either checkboxes or radio buttons depending on the options provided.
     * Builds (or reuses) a grid-layout container immediately after the dropdown containing one labeled checkbox (for multi-select dropdowns) or radio button (for single-select dropdowns) per non-ignored option, synchronizes changes on those inputs back to the original dropdown's selection, applies the dropdown's current selection to the generated inputs, and hides the original dropdown in favor of the generated container.
     * @param properties Configuration identifying the source dropdown, the generated container's id and layout, the input group name, and any option values to exclude
     */
    public static replaceDropdownWithOptionInputs(properties: DropdownOptionInputsReplacementProperties): void {
        let propertiesWithDefaults = Object.assign(new DropdownOptionInputsReplacementProperties(), properties);

        let jDropdown = jQuery<HTMLSelectElement>(propertiesWithDefaults.dropdownSelector);
        if (jDropdown.length > 0) {
            let isMultiSelect = jDropdown.prop("multiple");
            let inputType = isMultiSelect ? "checkbox" : "radio";

            // ensure container exists and is clean
            // setup container as grid display
            let jContainer = jQuery("#" + propertiesWithDefaults.optionsContainerId);
            if (jContainer.length === 0) {
                jContainer = jQuery("<div>", {
                    id: propertiesWithDefaults.optionsContainerId
                });

                // Insert right after the select
                jDropdown.after(jContainer);
            }
            jContainer.empty();
            jContainer.css({
                display: "grid",
                "grid-template-columns": "repeat(" + propertiesWithDefaults.numberOfColumns + ", 1fr)",
                gap: "8px"
            });

            // build the label and option inputs
            // ignore empty options or those part of the ignore list
            jDropdown.find("option").each(function () {
                let jOption = jQuery(this);
                let optionValue = jOption.val() || "";
                if (!Helper.isStringNullOrEmpty(optionValue) && !propertiesWithDefaults.optionsIgnoreList?.includes(optionValue)) {
                    // use flexbox display to align the input and label
                    let jLabel = jQuery("<label>").css({
                        display: "flex",
                        "align-items": "center",
                        gap: "6px"
                    });
                    let jInput = jQuery("<input>", {
                        type: inputType,
                        name: propertiesWithDefaults.optionsNameId,
                        value: jOption.val(),
                        checked: jOption.is(":selected")
                    }).css({
                        "margin-top": "0px"
                    });

                    jLabel.append(jInput).append(jOption.text());
                    jContainer.append(jLabel);
                }
            });

            // sync values from the options to the select dropdown
            // ensure you remove the previous change input handler
            jContainer.off("change", "input").on("change", "input", function () {
                var val = jQuery(this).val();

                if (isMultiSelect) {
                    jDropdown.find('option[value="' + val + '"]')
                        .prop("selected", jQuery(this).is(":checked"));
                } else {
                    jDropdown.val(val);
                }

                jDropdown.trigger("change");
            });

            // sync values from the select dropdown to the options initially
            let dropdownValue = jDropdown.val() || [];
            let selectedValueList = Array.isArray(dropdownValue) ? dropdownValue : [dropdownValue];
            jContainer.find("input").each(function () {
                let jInput = jQuery(this);
                let inputValue = jInput.val() || "";
                let isChecked = selectedValueList.indexOf(inputValue) !== -1;
                jInput.prop("checked", isChecked);
            });

            // hide the original dropdown and show the final container
            jDropdown.hide();
            jContainer.show();
        }
    }

}
